import { cn } from '@/lib/utils';
import { useState } from 'react';

type Props = { name: string; logo: string; color: string; size?: 'md' | 'lg' | 'xl' };

export function PlatformLogo({ name, logo, color, size = 'md' }: Props) {
	const [failedLogo, setFailedLogo] = useState<string>();
	const hasImageError = !logo || failedLogo === logo;

	return (
		<span
			className={cn(
				'relative grid size-11 shrink-0 place-items-center overflow-hidden rounded-xl text-lg font-extrabold text-white',
				size === 'lg' && 'size-20 rounded-[1.25rem] text-3xl',
				size === 'xl' && 'size-30 rounded-[1.8rem] text-4xl',
			)}
			style={{ backgroundColor: color }}
		>
			{!hasImageError && (
				<img
					src={logo}
					alt=""
					className="absolute size-full object-contain p-1.5"
					onError={() => setFailedLogo(logo)}
				/>
			)}
			{hasImageError && <span>{name.charAt(0).toUpperCase()}</span>}
		</span>
	);
}
